// extracted by mini-css-extract-plugin
export default {"rating":"DI-z","numberOfStars":"EI-z","count":"FI-z","barGraphSpacing":"GI-z","barGraph":"HI-z"};